document.addEventListener('DOMContentLoaded', function() {
  const ensurePopupVideo = (popup) => {
    if (!popup) return null;

    let video = popup.querySelector('video');
    if (video) return video;

    const videoSrc = popup.dataset.videoSrc;
    if (!videoSrc) return null;

    video = document.createElement('video');
    video.className = 'pvideo_video';
    video.controls = true;
    video.playsInline = true;
    video.preload = 'metadata';

    if (popup.dataset.videoPoster) {
      video.poster = popup.dataset.videoPoster;
    }

    const source = document.createElement('source');
    source.src = videoSrc;
    source.type = 'video/mp4';
    video.appendChild(source);

    popup.innerHTML = '';
    popup.appendChild(video);

    return video;
  };

  const closePopupVideo = (parent) => {
    if (!parent) return;

    const activePopup = parent.querySelector('.ppopup_show');
    const activeVideo = activePopup ? activePopup.querySelector('video') : null;
    if (activeVideo) {
      activeVideo.pause();
    }

    document.querySelectorAll('.pvideo_popup').forEach(el => {
      el.classList.remove('ppopup_show');
      el.innerHTML = '<div class="pvideo_video_placeholder"></div>';
    });

    parent.classList.remove('video_popups_show');
  };

  document.addEventListener('click', (e) => {
    const bundle_item = e.target.closest('.lineitem_bundle_item');
    if (bundle_item) {
      const qty = bundle_item.getAttribute('data_qty');
      const parent = bundle_item.closest('.line-item');
      const qty_input = parent.querySelector('.quantity-selector__input');

      if (qty_input) {
        qty_input.value = parseInt(qty);
        qty_input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    //---------------- Start - Produktbilder testen ----------------

    const pvideos_toggle = e.target.closest('.pvideos_toggle');
    if (pvideos_toggle) {
      const pvideos_wrapper = document.querySelector('.pvideos_list_wrapper');
      if (pvideos_wrapper) {
        pvideos_wrapper.classList.toggle('pvideos_wrapper_active');
      }
    }
    const pvideo_item = e.target.closest('.pvideo_item');
    if(pvideo_item){
      const popup_id = pvideo_item.getAttribute('popup');
      const popup = document.querySelector(`.pvideo_popup[popup="${popup_id}"]`);
      if(popup){
        const parent = popup.closest('.video_popups_main');
        parent.classList.add('video_popups_show');
        popup.classList.add('ppopup_show');
        const video = ensurePopupVideo(popup);
        if (video) {
          video.play();
        }
      }
    }
    const video_overlay = e.target.closest('.video_popup_overlay');
    if(video_overlay){
      const parent = video_overlay.closest('.video_popups_main');
      closePopupVideo(parent);
    }
    const video__close = e.target.closest('.video_popup_close');
    if(video__close){
      const parent = video__close.closest('.video_popups_main');
      closePopupVideo(parent);
    }  
    //---------------- End - Produktbilder testen ----------------

  });
});


document.addEventListener('click', function(event) {
  const free_gift_btn = event.target.closest('.fgi-atc-btn');
  if (!free_gift_btn) return;

  const gift_id = parseInt(free_gift_btn.getAttribute('data-id'));
  if (!gift_id) return;

  free_gift_btn.setAttribute('disabled', true);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: gift_id,
          quantity: 1,
          properties:{
            free_gift_item:true
          }
        }
      ]
    })
  })
  .then(res => res.json())
  .then(cartData => {
    free_gift_btn.removeAttribute('disabled');
    fetch('/cart.js', {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(data => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart: data, openMiniCart: true, replacementDelay: 0 }
          })
        );
    });
  })
  .catch(err => {
    free_gift_btn.removeAttribute('disabled');
    console.error("❌ Error adding bundle:", err);
  });
});

document.addEventListener('cart:refresh', function(event) {
  const mini_drawer = document.querySelector('#mini-cart');
  if (!mini_drawer) return;

  const cart = event.detail?.cart;
  if (!cart || !cart.items) return;

  const freegift_count = parseInt(mini_drawer.getAttribute('data-freegift-count'));

  const freeGiftItems = cart.items.filter(item => 
    item.properties && item.properties.free_gift_item
  );

  if (!freeGiftItems.length) return;

  if (cart.item_count < freegift_count) {

    const updates = {};

    freeGiftItems.forEach(item => {
      updates[item.key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(updatedCart => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart,
            openMiniCart: true,
            replacementDelay: 0
          }
        })
      );
    })
    .catch(err => console.error('Free gift remove error:', err));
  }
});



let select_qty = 2;
document.addEventListener('change', function (event) {
  const bundleInput = event.target.closest('.kaching-bundles__bar input');
  const colorSwatch = event.target.closest('.color-swatch__radio_child');

  /* ---------------- Bundle quantity change ---------------- */
  if (bundleInput) {
    console.log('bundleInput');
    const bar = bundleInput.closest('.kaching-bundles__bar');
    if (!bar) return;

    const titleEl = bar.querySelector('.kaching-bundles__bar-title');
    if (!titleEl) return;

    const number = parseInt(titleEl.textContent.match(/\d+/)?.[0], 10);
    if (!number) return;

    // Reset all
    $('.color-swatch-bundle-item').removeClass('show-swatch-list');

    // Show required items
    for (let i = 1; i <= number; i++) {
      $(`.color-swatch-bundle-item[item="${i}"]`)
        .addClass('show-swatch-list');
    }
    document.querySelector('.selected_option_count').textContent = number;
    select_qty = number;
    freeShippingToggle(select_qty);

      setTimeout(() => {
        const parent = document.querySelector('.kaching-bundles__bar--selected');
        parent.querySelectorAll('.kaching-bundles__swatch-dropdown').forEach((el, index) => {
          const dataValue = el.getAttribute('data-value');
          const swatch_ = document.querySelector(
            `.show-swatch-list[item="${index + 1}"]`
          );
          const input = swatch_.querySelector(
            `.color-swatch__radio_child[value="${CSS.escape(dataValue)}"]`
          );
          if (input) {
            input.checked = true;
          }
        });
      }, 100);
  }

  /* ---------------- Color swatch change ---------------- */
  if (colorSwatch) {
    const item = parseInt(colorSwatch.getAttribute('item'), 10);
    const value = colorSwatch.value;
    const value_index = parseInt(colorSwatch.getAttribute('value_index'), 10);
    if (!item || !value) return;

    document.querySelector(`.show-swatch-list[item="${item}"]`).querySelector('.item_selected_value').textContent = value;

    if(item == 1 && select_qty != 1){

      const parent = document.querySelector('.kaching-bundles__bar--selected');
      if (!parent) return;

      const dropdown = parent.querySelectorAll(
        '.kaching-bundles__bar-variant-selector-wrapper'
      )[item - 1];

      if (!dropdown) return;

      const dropdownBtn = dropdown.querySelector(
        '.kaching-bundles__bar-variant-select'
      );
      const selectBtn = dropdown.querySelector(
        'select.kaching-bundles__bar-variant-select[data-name="Farbe"]'
      );
      let allSame = true;
      if (dropdownBtn){
        dropdownBtn.click();
        setTimeout(() => {
          const swatchBtn = dropdown.querySelector(
            `.kaching-bundles-option-value[data-value="${CSS.escape(value)}"]`
          );
          swatchBtn?.click();
        }, 200);
        setTimeout(() => {
          parent.querySelectorAll('.kaching-bundles__swatch-dropdown').forEach(el => {
            const dataValue = el.getAttribute('data-value');
            if (dataValue != value) {
              allSame = false;
            }
          });
          if (allSame) {
            document.querySelectorAll('.show-swatch-list:not([item="1"])').forEach(el => {
              const input = el.querySelector(`.color-swatch__radio_child[value="${CSS.escape(value)}"]`);
              if (input) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          }
        },400);
      }
      if(selectBtn){
          setTimeout(() => {
            selectBtn.selectedIndex = value_index;
            selectBtn.dispatchEvent(new Event('change', { bubbles: true }));
          }, 200);
          setTimeout(() => {
            parent.querySelectorAll('.kaching-bundles-option').forEach(el => {
              const dataValue = el.value;
              if (dataValue != value) {
                allSame = false;
              }
            });
            if (allSame) {
              document.querySelectorAll('.show-swatch-list:not([item="1"])').forEach(el => {
                const input = el.querySelector(`.color-swatch__radio_child[value="${CSS.escape(value)}"]`);
                if (input) {
                  input.checked = true;
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
            }
          },400);
      }
    }
    else if(item == 1 && select_qty == 1){
      const swatch__radio = document.querySelector(`.color-swatch .color-swatch__radio[value="${value}"]`);
      if(swatch__radio){
        swatch__radio.checked = true;
        swatch__radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    else{

      const parent = document.querySelector('.kaching-bundles__bar--selected');
      if (!parent) return;

      const dropdown = parent.querySelectorAll(
        '.kaching-bundles__bar-variant-selector-wrapper'
      )[item - 1];

      if (!dropdown) return;

      const dropdownBtn = dropdown.querySelector(
        '.kaching-bundles__bar-variant-select'
      );
      const selectBtn = dropdown.querySelector(
        'select.kaching-bundles__bar-variant-select[data-name="Farbe"]'
      );
      if (dropdownBtn){
        dropdownBtn.click();
        setTimeout(() => {
          const swatchBtn = dropdown.querySelector(
            `.kaching-bundles-option-value[data-value="${CSS.escape(value)}"]`
          );
          swatchBtn?.click();
        }, 200); 
      }
      if(selectBtn){
        setTimeout(() => {
          selectBtn.selectedIndex = value_index;
          selectBtn.dispatchEvent(new Event('change', { bubbles: true }));
        }, 200); 
      }
    }
  }

});

let attempts = 0;
const findcatching = setInterval(() => {
  attempts++;

  const wrapper = document.querySelector('.kaching-bundles__bars');
  if (!wrapper) {
    if (attempts >= 8) clearInterval(findcatching);
    return;
  }

  const selected = wrapper.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected');
  if (!selected) {
    if (attempts >= 8) clearInterval(findcatching);
    return;
  }

  const bars = [...wrapper.querySelectorAll('.kaching-bundles__bar')];
  const position = bars.indexOf(selected);
  const select_qty = position + 1;

  document.querySelectorAll('.color-swatch-bundle-item').forEach((el, index) => {
    if ((index + 1) <= select_qty) {
      el.classList.add('show-swatch-list');
    } else {
      el.classList.remove('show-swatch-list');
    }
  });
  clearInterval(findcatching);
}, 1000);

document.addEventListener('DOMContentLoaded', function () {

  const inventory_wrapper = document.querySelector('.product-form__inventory-wrapper');
  const bundle_inventory_status = document.querySelector('.bundle_inventory_status');
  if (inventory_wrapper && bundle_inventory_status) {
    const inventoryObserver = new MutationObserver(() => {
      bundle_inventory_status.innerHTML = inventory_wrapper.innerHTML;
    });
    inventoryObserver.observe(inventory_wrapper, {
      childList: true,
      subtree: true,
      characterData: true
    });
    bundle_inventory_status.innerHTML = inventory_wrapper.innerHTML;
  }

  const free_gift_wrapper = document.querySelector('.pdp_free_gift');
  if(free_gift_wrapper){
    const free_gift_toggle = document.querySelector('.pdp_free_gift_toggle');
    if (free_gift_toggle) {
      free_gift_toggle.addEventListener('change', function () {
        document.querySelectorAll('.free_gift_select').forEach((input) => {
          input.disabled = !this.checked;
        });
      });
    }
    document.addEventListener('ed:qty:change', function(e){
      const qty = e.detail.value;
      freeShippingToggle(qty);
    });
  }

});

function freeShippingToggle(qty){
  const fg_wrapper = document.querySelector('.pdp_free_gift');
  const mn_drawer = document.querySelector('#mini-cart');
  const threshold = mn_drawer.getAttribute('minimum_qty');
  const fg_toggle = document.querySelector('.pdp_free_gift_toggle');
  if (fg_toggle) {
    if (qty >= threshold) {
      fg_wrapper.classList.add('fg_wrapper_active');
    } else {
      fg_wrapper.classList.remove('fg_wrapper_active');
      fg_toggle.checked = false;
      fg_toggle.dispatchEvent(new Event('change'));
    }
  }
}


let isUpdatingFreeGift = false;

document.addEventListener('cart:refresh', function(event) {
  if (isUpdatingFreeGift) return;

  const mini_drawer = document.querySelector('#mini-cart');
  if (!mini_drawer) return;

  const cart = event.detail?.cart;
  if (!cart || !cart.items) return;

  const minimum_qty = parseInt(mini_drawer.getAttribute('minimum_qty') || 0);

  const freeGiftItems = cart.items.filter(item => item.properties && item.properties.free_gift_id);

  freeGiftItems.forEach((freeGiftItem) => {
    const targetProductId = freeGiftItem.properties.free_gift_id;

    const parentQty = cart.items
      .filter(item => item.product_id == targetProductId)
      .reduce((sum, item) => sum + item.quantity, 0);

    if (parentQty < minimum_qty) {
      isUpdatingFreeGift = true;
      updateFreeGift(freeGiftItem.variant_id, 0);
      return;
    }

    if (freeGiftItem.quantity > 1) {
      isUpdatingFreeGift = true;
      updateFreeGift(freeGiftItem.variant_id, 1);
      return;
    }
  });
});

function updateFreeGift(variantId, qty) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      updates: {
        [variantId]: qty
      }
    })
  })
  .then(res => res.json())
  .then(updatedCart => {
    isUpdatingFreeGift = false;

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: updatedCart,
          openMiniCart: true,
          replacementDelay: 0
        }
      })
    );
  })
  .catch(err => {
    isUpdatingFreeGift = false;
    console.error('Free gift update error:', err);
  });
}
